import commonFunc from '../../../common.func'
import constant from '../../../main.constants';
const state = () => ({
    candidateHeaders: [
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.id"),
            value: "id",
            filterType: "Number",
            datatype: "Number",
            columnName: "id",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.name"),
            value: "name",
            filterType: "String",
            datatype: "String",
            columnName: "name",
            canBeHidden: false
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.description"),
            value: "description",
            filterType: "String",
            datatype: "String",
            columnName: "description",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.ruleName"),
            value: "ruleName",
            filterType: "String",
            datatype: "String",
            columnName: "ruleName",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.state"),
            value: "candidateState",
            filterType: "Numeric",
            datatype: "Numeric",
            columnName: "candidateState",
            formatter: (item) => {
                if (constant.RULESTATENAMES[item.candidateState]) {
                    return commonFunc.localize(`fraud.rules.ruleStates.${constant.RULESTATENAMES[item.candidateState]}`);
                }
                return "";
            },
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.updatedBy"),
            value: "updatedBy",
            filterType: "String",
            datatype: "String",
            columnName: "updatedBy",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.updateDate"),
            value: "updateDate",
            filterType: "DateTime",
            datatype: "DateTime",
            columnName: "updateDate",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.notes"),
            value: "notes",
            filterType: "String",
            datatype: "String",
            columnName: "notes",
        },
        {
            sortable: false,
            text: commonFunc.localize("İşlemler"),
            value: "actions",
            width: "300px",
        },
    ],
    ruleHeaders: [
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.id"),
            value: "id",
            filterType: "Number",
            datatype: "Number",
            columnName: "id",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.name"),
            value: "name",
            filterType: "String",
            datatype: "String",
            columnName: "name",
            canBeHidden: false,
            width: "310px",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.description"),
            value: "description",
            filterType: "String",
            datatype: "String",
            columnName: "description",
            width: "310px",
        },
        {
            sortable: false,
            text: commonFunc.localize("actions"),
            value: "actions",
            width: "200px",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.ruleHasCandidate"),
            value: "ruleHasCandidate",
            filterType: "Boolean",
            datatype: "Boolean",
            columnName: "ruleHasCandidate",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.isStaticQuery"),
            value: "isStaticQuery",
            filterType: "Boolean",
            datatype: "Boolean",
            columnName: "isStaticQuery",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.createdBy"),
            value: "createdBy",
            filterType: "String",
            datatype: "String",
            columnName: "createdBy",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.createDate"),
            value: "createDate",
            filterType: "DateTime",
            datatype: "DateTime",
            columnName: "createDate",
            width: "170px",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.updatedBy"),
            value: "updatedBy",
            filterType: "String",
            datatype: "String",
            columnName: "updatedBy",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.updateDate"),
            value: "updateDate",
            filterType: "DateTime",
            datatype: "DateTime",
            columnName: "updateDate",
            width: "170px",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.approvedBy"),
            value: "approvedBy",
            filterType: "String",
            datatype: "String",
            columnName: "approvedBy",
        },
        {
            sortable: true,
            text: commonFunc.localize("fraud.rules.headers.approveDate"),
            value: "approveDate",
            filterType: "DateTime",
            datatype: "DateTime",
            columnName: "approveDate",
            width: "170px",
        }
    ],
    data: [],
    loading: false,
    isAddForm: true,
    selectedState: null
});

export default state;